import ImagesSlider from 'assets/core/js/module/imagesSlider'
import { initZoomMediasPanel } from 'assets/core/js/page/product/zoomMediasPanel'
import type { Swiper } from 'swiper'

const initProductSlider = (): string | undefined => {
  const el = document.querySelector<HTMLElement>('.product__images .swiper')

  if (!el) {
    return
  }

  const sliderId = ImagesSlider(
    el,
    {
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (_swiper: Swiper, current: number, total: number) {
          return `${current}/${el.hasAttribute('data-total-images') ? (el.getAttribute('data-total-images') as string) : total}`
        },
      },
      spaceBetween: 10,
    },
    false
  )

  return sliderId
}

export default function (): void {
  initProductSlider()

  document.querySelectorAll<HTMLImageElement>('.product__images img').forEach((img) => {
    initZoomMediasPanel(img, true)
  })
}
